/** small to large */
export var breakpointList = ['xs', 'sm', 'md', 'lg', 'xl'];
